<template>
    <div id="login">
        <!-- 顶部导航栏 -->
        <div class="login-nav">
            <div class="login-nav-inner">
                <div class="nav-logo"><img src="~@/assets/logo.png"/></div>
                <div class="nav-title">新程悦居酒店管理系统</div>
            </div>
        </div>
        <!-- 横幅区域 -->
        <div class="login-banner">
            <!-- 左侧宣传区 -->
            <div class="banner-left">
                <div class="promo-title">告别繁重，让生意更轻松</div>
                <div class="promo-divider"></div>
                <div class="promo-subtitle">酒店管理、运营、营销一站式服务软件</div>
            </div>
            <!-- 右侧登录卡片 -->
            <div class="banner-right">
                <div class="login-card">
                    <div class="card-title">酒店管理系统</div>
                    <div class="card-item">
                        <input type="text" v-model="username" placeholder="请输入用户名"/>
                    </div>
                    <div class="card-item">
                        <input type="password" v-model="password" placeholder="请输入用户密码"/>
                    </div>
                    <div class="card-item yan_item">
                        <input type="text" v-model="verifycode" placeholder="请输入验证码"/>
                        <div class="yanzhengm" @click="getVerifyCodeImg"><img :src="verifyImg"></div>
                    </div>
                    <!-- <div class="card-item">
                        <div class="captcha-link"><a href="javascript:void(0)" @click="getVerifyCodeImg">验证码登录</a></div>
                    </div> -->
                    <div class="card-item btn_row">
                        <a href="javascript:void(0)" class="login-btn" @click="login">登录</a>
                        <a href="javascript:void(0)" class="register-btn" @click="showRegister">注册</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部信息栏 -->
        <div class="login-footer">
            <div class="footer-content">
                <div class="footer-left">
                    <div class="footer-company">贵州未来信息技术有限公司</div>
                    <div class="footer-info-item">
                        <div class="info-icon">&#9742;</div>
                        <span>联系电话：18983168104</span>
                    </div>
                    <div class="footer-info-item">
                        <div class="info-icon">&#9993;</div>
                        <span>邮箱：1013760813@qq.com</span>
                    </div>
                    <div class="footer-info-item">
                        <div class="info-icon">&#9906;</div>
                        <span>地址：贵州省遵义市播州区桂花桥街道天池大街南侧丰乐·未来城二期1-3号楼裙楼1-1-7</span>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="qr-placeholder"><span>二维码</span></div>
                    <div class="qr-label">扫码加微信</div>
                </div>
            </div>
            <div class="footer-bottom">
                贵州未来信息技术有限公司 版权所有 黔ICP备2026014368号-1
            </div>
        </div>
        <!-- 用户须知对话框 -->
        <div class="notice-mask" v-if="showNoticeDialog" @click.self="closeNotice">
            <div class="notice-box">
                <div class="notice-header">
                    <span>用户注册须知</span>
                </div>
                <div class="notice-content">
                    <div class="notice-title">欢迎注册新程悦居酒店管理系统</div>
                    <div class="notice-section">
                        <p>一、注册用户在填写真实有效的酒店信息，包括酒店名称、地址、联系方式、营业执照及法人身份证等。</p>
                        <p>二、用户须保证所提供的资料真实、合法、有效，并承担因信息不实或虚假信息引起的一切法律责任。</p>
                        <p>三、系统将在审核通过后自动生成默认账号和密码，请妥善保管并及时修改密码，因账号保管不善造成的损失由用户自行承担。</p>
                        <p>四、用户应遵守国家相关法律法规及平台规定，不得利用本平台从事任何违法违规活动。</p>
                        <p>五、平台有权对违反规定的账号进行冻结或注销处理，并保留追究法律责任的权利。</p>
                        <p>六、本须知最终解释权归新程悦居酒店管理系统所有。</p>
                    </div>
                    <div class="notice-btns">
                        <a href="javascript:void(0)" class="notice-disagree" @click="closeNotice">不同意</a>
                        <a href="javascript:void(0)" class="notice-agree" @click="agreeNotice">同意并继续</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 注册结果页 -->
        <div class="register-result-mask" v-if="showRegisterResult">
            <div class="register-result-box">
                <div class="result-header">
                    <span>注册结果</span>
                </div>
                <div class="result-content">
                    <div class="result-success-icon">&#10004;</div>
                    <div class="result-icon-tip">恭喜您，酒店注册已提交成功！</div>
                    <div class="result-info-item">
                        <label>用户名：</label>
                        <span>{{ registerResult.storeUsername }}</span>
                    </div>
                    <div class="result-info-item">
                        <label>默认密码：</label>
                        <span>{{ registerResult.storePassword }}</span>
                    </div>
                    <div class="result-tip">请妥善保存您的账号信息，登录后及时修改密码</div>
                    <div class="result-btns">
                        <a href="javascript:void(0)" class="result-close-btn" @click="goToLogin">关闭</a>
                        <a href="javascript:void(0)" class="result-login-btn" @click="goToLogin">去登录</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 注册对话框 -->
        <div class="register-mask" v-if="showRegisterDialog" @click.self="closeRegister">
            <div class="register-box">
                <div class="register-header">
                    <span>酒店注册</span>
                    <a href="javascript:void(0)" @click="closeRegister">&times;</a>
                </div>
                <div class="register-content">
                    <div class="reg-item">
                        <label>酒店名称：</label>
                        <input type="text" v-model="regForm.storeName" placeholder="请输入酒店名称"/>
                    </div>
                    <div class="reg-item">
                        <label>酒店类型：</label>
                        <select v-model="regForm.storeType">
                            <option value="" disabled>请选择酒店类型</option>
                            <option v-for="item in hotelTypeOptions" :key="item.storeType" :value="item.storeType">{{ item.storeTypeName }}</option>
                        </select>
                    </div>
                    <div class="reg-item">
                        <label>酒店地址：</label>
                        <input type="text" v-model="regForm.storeAddr" placeholder="请输入酒店地址"/>
                    </div>
                    <div class="reg-item">
                        <label>酒店电话：</label>
                        <input type="text" v-model="regForm.storeTel" placeholder="请输入酒店电话"/>
                    </div>
                    <div class="reg-item">
                        <label>统一社会信用代码：</label>
                        <input type="text" v-model="regForm.storeIcNo" placeholder="请输入统一社会信用代码"/>
                    </div>
                    <div class="reg-item reg-img-item">
                        <label>营业执照：</label>
                        <div class="reg-license-container">
                            <div class="reg-license-item">
                                <div class="reg-picbox">
                                    <PicInput v-if="!regForm.storeIcSrc" v-model="regForm.storeIcSrc" :inputid="'reg_ic'"/>
                                    <div class="reg-imgshowbox" v-if="regForm.storeIcSrc">
                                        <a href="javascript:void(0)" @click="deleteRegPic(1)">x</a>
                                        <img :src="regForm.storeIcSrc.fileFullPath" @click="showimg(regForm.storeIcSrc.fileFullPath)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reg-item">
                        <label>法定代表人姓名：</label>
                        <input type="text" v-model="regForm.storeLegeName" placeholder="请输入法定代表人姓名"/>
                    </div>
                    <div class="reg-item">
                        <label>法定代表人身份证：</label>
                        <input type="text" v-model="regForm.storeLegeNo" placeholder="请输入法定代表人身份证号"/>
                    </div>
                    <div class="reg-item">
                        <label>法定代表人电话：</label>
                        <input type="text" v-model="regForm.storeLegePhone" placeholder="请输入法定代表人电话"/>
                    </div>
                    <div class="reg-item reg-img-item">
                        <label>身份证照片：</label>
                        <div class="reg-license-container">
                            <div class="reg-license-item">
                                <span class="reg-license-label">正面：</span>
                                <div class="reg-picbox">
                                    <PicInput v-if="!regForm.storeLegIc1Src" v-model="regForm.storeLegIc1Src" :inputid="'reg_ic1'"/>
                                    <div class="reg-imgshowbox" v-if="regForm.storeLegIc1Src">
                                        <a href="javascript:void(0)" @click="deleteRegPic(2)">x</a>
                                        <img :src="regForm.storeLegIc1Src.fileFullPath" @click="showimg(regForm.storeLegIc1Src.fileFullPath)">
                                    </div>
                                </div>
                            </div>
                            <div class="reg-license-item">
                                <span class="reg-license-label">反面：</span>
                                <div class="reg-picbox">
                                    <PicInput v-if="!regForm.storeLegIc2Src" v-model="regForm.storeLegIc2Src" :inputid="'reg_ic2'"/>
                                    <div class="reg-imgshowbox" v-if="regForm.storeLegIc2Src">
                                        <a href="javascript:void(0)" @click="deleteRegPic(3)">x</a>
                                        <img :src="regForm.storeLegIc2Src.fileFullPath" @click="showimg(regForm.storeLegIc2Src.fileFullPath)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reg-item reg-btns">
                        <a href="javascript:void(0)" class="reg-cancel" @click="closeRegister">取消</a>
                        <a href="javascript:void(0)" class="reg-submit" @click="handleRegister">提交注册</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 图片放大查看 -->
        <div id="reg_showimgbox" v-if="showimg_src" @click.self="closeshowimgbox">
            <a href="javascript:void(0);" @click="closeshowimgbox">关闭</a>
            <img :src="showimg_src" @load="loadimgfun" ref="regImageElement" :style="{width:show_img_width+'px',
               height:show_img_height+'px',marginTop:(0-(show_img_height/2))+'px',marginLeft:(0-(show_img_width/2))+'px'}"></img>
        </div>
    </div>
</template>
<script>
    import Storage from '@/tools/Storage'
    import { ElMessage } from 'element-plus';
    import {userlogin,selectNavList,selectRouteList,getverifycode,storeRegister,selectStoreType} from '@/tools/Api'
    import PicInput from '@/pages/common/PicInput.vue'
     export default{
          name:"Login",
          components:{
              PicInput
          },
          data(){
            return{
              username:"",
              password:"",
              verifyImg:"",
              verifyCodeId:"",
              verifycode:"",
              showNoticeDialog:false,
              showRegisterDialog:false,
              showRegisterResult:false,
              showimg_src:"",
              show_img_width:0,
              show_img_height:0,
              registerResult:{
                  storeUsername:"",
                  storePassword:"",
                  storeUid:""
              },
              hotelTypeOptions:[],
              regForm:{
                  storeName:"",
                  storeType:"",
                  storeAddr:"",
                  storeTel:"",
                  storeIcNo:"",
                  storeIcSrc:"",
                  storeLegeName:"",
                  storeLegeNo:"",
                  storeLegePhone:"",
                  storeLegIc1Src:"",
                  storeLegIc2Src:""
              }
            }
          },
          mounted(){
            this.getVerifyCodeImg()
            this.username=""
            this.password=""
            this.verifycode=""

          },
          methods:{
                goToLogin(){
                    this.showRegisterResult=false
                    this.registerResult={storeUsername:"",storePassword:"",storeUid:""}
                },
                deleteRegPic(index){
                    if(index==1){
                        this.regForm.storeIcSrc=''
                    }else if(index==2){
                        this.regForm.storeLegIc1Src=''
                    }else if(index==3){
                        this.regForm.storeLegIc2Src=''
                    }
                },
                showimg(src){
                    this.showimg_src=src
                },
                closeshowimgbox(){
                    this.showimg_src=""
                    this.show_img_width=0
                    this.show_img_height=0
                },
                async loadimgfun(){
                    let w=0
                    let h=0
                    const img=this.$refs.regImageElement
                    if(!img) return
                    w=img.naturalWidth
                    h=img.naturalHeight
                    if(w>h){
                        this.show_img_width=600
                        this.show_img_height=Math.round(w/600*h)
                    }else{
                        this.show_img_height=600
                        this.show_img_width=Math.round(h/600*w)
                    }
                },
                showRegister(){
                    this.showNoticeDialog=true
                },
                closeNotice(){
                    this.showNoticeDialog=false
                },
                agreeNotice(){
                    this.showNoticeDialog=false
                    this.showRegisterDialog=true
                    this.getHotelTypeList()
                },
                closeRegister(){
                    this.showRegisterDialog=false
                    this.resetRegForm()
                },
                resetRegForm(){
                    this.regForm={
                        storeName:"",
                        storeType:"",
                        storeAddr:"",
                        storeTel:"",
                        storeIcNo:"",
                        storeIcSrc:"",
                        storeLegeName:"",
                        storeLegeNo:"",
                        storeLegePhone:"",
                        storeLegIc1Src:"",
                        storeLegIc2Src:""
                    }
                },
                getHotelTypeList(){
                    selectStoreType().then(res=>{
                        if(res.status==0 && res.data && res.data.length>0){
                            this.hotelTypeOptions=res.data
                        }
                    }).catch(error=>{
                        console.log(error)
                    })
                },
                checkRegInput(){
                    if(!this.regForm.storeName || this.regForm.storeName.trim().length<1){
                        ElMessage({message:'酒店名称不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeType){
                        ElMessage({message:'请选择酒店类型',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeAddr || this.regForm.storeAddr.trim().length<1){
                        ElMessage({message:'酒店地址不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeTel || this.regForm.storeTel.trim().length<1){
                        ElMessage({message:'酒店电话不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeIcNo || this.regForm.storeIcNo.trim().length<1){
                        ElMessage({message:'统一社会信用代码不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeIcSrc){
                        ElMessage({message:'请上传营业执照图片',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeLegeName || this.regForm.storeLegeName.trim().length<1){
                        ElMessage({message:'法定代表人姓名不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeLegeNo || this.regForm.storeLegeNo.trim().length<1){
                        ElMessage({message:'法定代表人身份证号不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeLegePhone || this.regForm.storeLegePhone.trim().length<1){
                        ElMessage({message:'法定代表人电话不能为空',type:'error',duration:1500})
                        return false
                    }
                    if(!/^1[3-9]\d{9}$/.test(this.regForm.storeLegePhone)){
                        ElMessage({message:'法定代表人电话格式不正确',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeLegIc1Src){
                        ElMessage({message:'请上传身份证正面照片',type:'error',duration:1500})
                        return false
                    }
                    if(!this.regForm.storeLegIc2Src){
                        ElMessage({message:'请上传身份证反面照片',type:'error',duration:1500})
                        return false
                    }
                    return true
                },
                handleRegister(){
                    if(!this.checkRegInput()){
                        return
                    }
                    const params={
                        storeName:this.regForm.storeName,
                        storeType:this.regForm.storeType,
                        storeAddr:this.regForm.storeAddr,
                        storeTel:this.regForm.storeTel,
                        storeIcNo:this.regForm.storeIcNo,
                        storeIcSrc:this.regForm.storeIcSrc.fileFullPath,
                        storeLegeName:this.regForm.storeLegeName,
                        storeLegeNo:this.regForm.storeLegeNo,
                        storeLegePhone:this.regForm.storeLegePhone,
                        storeLegIc1Src:this.regForm.storeLegIc1Src.fileFullPath,
                        storeLegIc2Src:this.regForm.storeLegIc2Src.fileFullPath
                    }
                    storeRegister(params).then(res=>{
                        if(res.status==0){
                            this.registerResult={
                                storeUsername:res.data.storeUsername||"",
                                storePassword:res.data.storePassword||"",
                                storeUid:res.data.storeUid||""
                            }
                            this.showRegisterDialog=false
                            this.showRegisterResult=true
                            this.resetRegForm()
                        }else{
                            ElMessage({message:res.msg||'注册失败',type:'error',duration:1500})
                        }
                    }).catch(error=>{
                        console.log(error)
                        ElMessage({message:'请求失败',type:'error',duration:1500})
                    })
                },
                login() {
                    if(!this.checkInput()){
                       return
                    }
                    const formdata={
                        'username':this.username,
                        'password':this.password,
                        'verifyId':this.verifyCodeId,
                        'verifycode':this.verifycode
                    };
                    userlogin(formdata).then(response=>{
                         if(response.status==0){
                                Storage.commit("registUserInfo",{
                                    token:response.data.token
                                })
                                 ElMessage({
                                    message:'登录成功', 
                                    type:'success', 
                                    duration:1500
                                })
                               selectNavList().then(res=>{
                                    if(res.status==0){
                                        const menuList=JSON.stringify(res.data.list)
                                         sessionStorage.setItem("menuList",menuList)
                                        
                                    }
                                
                                }).catch(error=>{
                                    ElMessage({
                                        message:'请求失败！', 
                                        type:'error', 
                                        duration:1500
                                    })

                                })
                                selectRouteList().then(res=>{
                                    if(res.status==0){
                                        const menuList=JSON.stringify(res.data)
                                         sessionStorage.setItem("routemenuList",menuList)
                                          setTimeout(() => {
                                                this.$router.push({name:"home"})
                                            }, 1500);
                                    }
                                
                                }).catch(error=>{
                                    ElMessage({
                                        message:'请求失败！', 
                                        type:'error', 
                                        duration:1500
                                    })

                                })
                               
                                
                         }else{
                              ElMessage({
                                    message:response.msg, 
                                    type:'error', 
                                    duration:1500
                                })
                                this.getVerifyCodeImg()
                         }
                       
                    }).catch(error=>{
                        console.log(error)
                         ElMessage({
                            message:'请求失败', 
                            type:'error', 
                            duration:1500
                        })

                    })
                },
                getVerifyCodeImg(){
                    this.getverifycode=""
                    getverifycode(this.verifyCodeId).then(res=>{
                                    if(res.status==0){
                                        this.verifyCodeId=res.data.verifyId
                                        this.verifyImg=res.data.verifyImg
                                    }else{
                                       ElMessage({
                                            message:'请求失败！', 
                                            type:'error', 
                                            duration:1500
                                        }) 
                                    }
                                
                                }).catch(error=>{
                                    ElMessage({
                                        message:'请求失败！', 
                                        type:'error', 
                                        duration:1500
                                    })

                                })
                },
                checkInput(){
                    if(this.username.length<1){
                        ElMessage({
                            message:'用户名不能为空', 
                            type:'error', 
                            duration:1500
                        })
                        return false
                    }else if(this.password.length<1){
                        ElMessage({
                            message:'用户密码不能为空', 
                            type:'error', 
                            duration:1500
                        })
                        return false
                    }else if(this.verifycode.length<1){
                        ElMessage({
                            message:'验证码不能为空', 
                            type:'error', 
                            duration:1500
                        })
                        return false
                    }
                    return true
                }
          }
     }
</script>
<style scoped>
   @import url("~@/css/login.css");
</style>